import React from "react";
import { ContentCard } from "../../layout";
import { Box, Typography } from "@material-ui/core";
import { responseHandler } from "modules/reporting/utils/helper";
import { BoxLoading } from "../../skeleton/loading";
import { BoxError } from "../../skeleton/error";
import { fontTextStyle } from "modules/reporting/styles";

export default function CategoryTitleCardComponent({
	status,
    data,
    translate
}) {
	const fontClasses = fontTextStyle();

	const renderData = (data) => {

        if (Object.keys(data).length === 0 || !data.isSuccess){
            return null;
        }

        const category_detail = data.category_summary;
        return (
            <Box display="flex" flexDirection="column" style={{gap:"12px"}} justifyContent={"center"} alignContent="center">
                <Typography className={fontClasses.text__muted}>
                    Drilldown by category
                </Typography>
                <Box
                    display="flex"
                    style={{
                        gap: "12px",
                    }}
                    alignItems="center"
                >
                    <Typography className={fontClasses.text__card_title}>
                        {category_detail.name}
                    </Typography>
                </Box>
            </Box>
        )
    }

    return (
		<ContentCard>
			<Box
				padding="15px 20px"
			>
				{
                    responseHandler(
                        data.productCategoryDetailData,
                        status.isFetchingProductCategoryDetailData,
                        (
                            renderData(data.productCategoryDetailData)
                        ),
                        (
                            <BoxLoading />
                        ),
                        (
                            <>empty</>
                        ),
                        (
                            <>no result</>
                        ),
                        (
                            <BoxError 
                                title={translate("label.LOADING_FAILED")}
                                value={translate("paragraph.LOADING_FAILED_DESCRIPTION")}
                            />
                        )
                    )
                }
			</Box>
		</ContentCard>
    );
}